<div *ngIf="showSpinner" class="estensa-spinner">
    <mat-spinner></mat-spinner>
</div>
<div *ngIf="formData && !showSpinner" class="heigth-container-full" [ngClass]="{'incoming-page-container-toolupload': externalPage === 'incoming',
                                                    'mat-card-height-auto': externalPage !== 'incoming'}">
    <mat-card [ngClass]="{'mat-card-height-auto': externalPage === 'incoming',
                      'mat-card-height-full': externalPage !== 'incoming'}"
              appearance="outlined"
              class="coll-themed-class  full-width">
        <div id="toolupload-component">
            <form [formGroup]="formData" class="custom-col-class col-sm-6">
                <mat-card-title *ngIf="!toolbarAction">{{ 'ImageUpload' | translate }}</mat-card-title>
                <!--accordion -->
                <div *ngIf="externalPage === 'incoming'" class="example-action-buttons">
                    <button (click)="accordion.openAll()" class="btn btn-s btn-incoming" mat-button >{{'se-ui-selector-web_expand_all' | translate}}</button>
                    <button (click)="accordion.closeAll()" class="btn btn-s btn-incoming" mat-button>{{'se-ui-selector-web_collapse_all' | translate}}</button>
                </div>

                <mat-accordion #accordion="matAccordion" [multi]="externalPage === 'incoming'" class="example-headers-align">
                    <mat-expansion-panel [expanded]="true" formGroupName="patientData">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="flex-basis-revert">
                                {{'TitlePatientData' | translate}}
                            </mat-panel-title>
                            <mat-panel-description>
                                <div [style.visibility]="showFormValidation('patientData') ? 'visible' : 'hidden'" class="mat-node-status node-icon-edit"></div>
                                <div [style.visibility]="showFormError('patientData') ? 'visible' : 'hidden'" class="mat-node-status node-icon-error"></div>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <!-- dati paziente -->
                        <mat-card-content class="coll-themed-class border-1-solid margin-bottom-7-important flex-input-container">
                            <div>
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('patientData', 'issuer')}">{{'Issuer' | translate}}</mat-label>
                                    <input formControlName="issuer" id="issuer" matInput>
                                </mat-form-field>
                            </div>
                            <div>
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('patientData', 'patientId')}">{{'PatientIdentifier' | translate}}</mat-label>
                                    <input [placeholder]="'PatientIdentifier' | translate" formControlName="patientId" id="patientId" matInput>
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('patientData', 'surname')}">{{'LastName' | translate}}</mat-label>
                                    <input [placeholder]="'LastName' | translate" formControlName="surname" id="surname" matInput>
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('patientData', 'name')}">{{'FirstName' | translate}}</mat-label>
                                    <input [placeholder]="'FirstName' | translate" formControlName="name" id="name" matInput>
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('patientData', 'sex')}">{{'Sex' | translate}}</mat-label>
                                    <input [placeholder]="'Sex' | translate" formControlName="sex" id="sex" matInput>
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('patientData', 'taxCode')}">{{'TaxCode' | translate}}</mat-label>
                                    <input [placeholder]="'TaxCode' | translate" formControlName="taxCode" id="taxCode" matInput pattern="^([a-zA-Z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[a-zA-Z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[a-zA-Z]{1})$|([0-9]{11})$">
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('patientData', 'birthDate')}">{{'BirthDate' | translate}}</mat-label>
                                    <input [matDatepicker]="picker" formControlName="birthDate" matInput>
                                    <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                                    <mat-datepicker #picker typeof="date"></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </mat-card-content>
                    </mat-expansion-panel>

                    <mat-expansion-panel [expanded]="externalPage === 'incoming'" formGroupName="orderData">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="flex-basis-revert">
                                {{'OrderData' | translate}}
                            </mat-panel-title>
                            <mat-panel-description>
                                <div [style.visibility]="showFormValidation('orderData') ? 'visible' : 'hidden'" class="mat-node-status node-icon-edit"></div>
                                <div [style.visibility]="showFormError('orderData') ? 'visible' : 'hidden'" class="mat-node-status node-icon-error"></div>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <!-- dati ordine -->
                        <mat-card-content class="coll-themed-class border-1-solid margin-bottom-7-important flex-input-container">
                            <div>
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('orderData', 'orderDescription')}">{{'OrderDescription' | translate}}</mat-label>
                                    <input [placeholder]="'OrderDescription' | translate" formControlName="orderDescription" id="orderDescription" matInput>
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('orderData', 'orderDate')}">{{'OrderDate' | translate}}</mat-label>
                                    <input [matDatepicker]="picker2" formControlName="orderDate" matInput>
                                    <mat-datepicker-toggle [for]="picker2" matSuffix></mat-datepicker-toggle>
                                    <mat-datepicker #picker2 typeof="date"></mat-datepicker>
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('orderData', 'orderProvenance')}">{{'OrderProvenance' | translate}}</mat-label>
                                    <input [placeholder]="'OrderProvenance' | translate" formControlName="orderProvenance" id="orderProvenance" matInput>
                                </mat-form-field>
                            </div>

                            <div *ngIf="externalPage !== 'incoming' && !uploadInfo.OrderBusinessUnit">
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('orderData', 'orderBusinessUnit')}">{{'OrderBusinessUnit' | translate}}</mat-label>
                                    <div>
                                        <mat-select formControlName="orderBusinessUnit" id="orderBusinessUnit">
                                            <mat-option *ngFor="let option of options" [value]="option">{{option.description}}</mat-option>
                                        </mat-select>
                                    </div>
                                </mat-form-field>
                            </div>

                            <div *ngIf="externalPage !== 'incoming' && uploadInfo.OrderBusinessUnit">
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('orderData', 'orderBusinessUnit')}">{{'OrderBusinessUnit' | translate}}</mat-label>
                                    <div>
                                        <input [placeholder]="'OrderBusinessUnit' | translate" formControlName="orderBusinessUnit" id="description" matInput>
                                    </div>
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('orderData', 'orderNumber')}">{{'OrderNumber' | translate}}</mat-label>
                                    <input [placeholder]="'OrderNumber' | translate" formControlName="orderNumber" id="orderNumber" matInput>
                                </mat-form-field>
                            </div>
                        </mat-card-content>
                    </mat-expansion-panel>

                    <mat-expansion-panel formGroupName="physicianData">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="flex-basis-revert">
                                {{'OperatorAndPhysicianData' | translate}}
                            </mat-panel-title>
                            <mat-panel-description>
                                <div [style.visibility]="showFormValidation('physicianData') ? 'visible' : 'hidden'" class="mat-node-status node-icon-edit"></div>
                                <div [style.visibility]="showFormError('physicianData') ? 'visible' : 'hidden'" class="mat-node-status node-icon-error"></div>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <!-- dati Physician -->
                        <mat-card-content class="coll-themed-class border-1-solid margin-bottom-7-important flex-input-container">
                            <div>
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('physicianData', 'referringPhysicianName')}">{{'ReferringPhysicianFirstName' | translate}}</mat-label>
                                    <input [placeholder]="'ReferringPhysicianFirstName' | translate" formControlName="referringPhysicianName" id="referringPhysicianName" matInput>
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="se-form-field card-input-field">
                                    <mat-label [ngClass]="{'label-color' : isDisabledAndNotEmpty('physicianData', 'referringPhysicianSurname')}">{{'ReferringPhysicianSurname' | translate}}</mat-label>
                                    <input [placeholder]="'ReferringPhysicianSurname' | translate" formControlName="referringPhysicianSurname" id="referringPhysicianSurname" matInput>
                                </mat-form-field>
                            </div>
                        </mat-card-content>
                    </mat-expansion-panel>
                </mat-accordion>
            </form>

            <div class="col-sm-6 import-file-container">
                <import-file (fileData)="onFileUploaded($event)"
                             [acceptedTypeFile]="loadedData.acceptedFormats"
                             class="custom-col-class">
                </import-file>
            </div>
        </div>

        <file-upload [externalPage]="externalPage"
                     [filesList]="filesList"
                     [formData]="formData"
                     [loadedData]="loadedData"
                     [ngClass]="{'align-flex-end': externalPage !== 'incoming'}"
                     [toolbarAction]="toolbarAction"
                     (closeModalEvent)="closeModal()"
                     class="col-sm-12">
        </file-upload>

    </mat-card>

</div>

